import { Platform } from '@angular/cdk/platform';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'smsUrl',
  standalone: true,
})
export class SmsUrlPipe implements PipeTransform {
  private readonly platform = inject(Platform);

  transform(mobileNumber: string | undefined, ...[message]: [string]): string | null {
    if (!mobileNumber) {
      return null;
    }
    const bodyQueryParam = this.platform.IOS ? '&body=' : '?body=';

    const body = message ? `${bodyQueryParam}${encodeURIComponent(message)}` : '';

    return `sms:${mobileNumber.replace(/\s*/g, '')}${body}`;
  }
}
